import React from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  required,
} from "components/common";
import { FormGroup, SaveButton } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers, lifecycle } from "recompose";
import qs from "query-string";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";

export const HesaabEmployeeEdit = ({
  t,
  mode,
  item,
  form,
  onBack,
  setDispatch,
  onSubmit: onSubmitProp,
  onUpdate,
  onChange,
  roles,
  renderServerError,
  readOnly,
  redirectUrl,
  onDisconnected,
  onDropAccepted,
  onLogoLoad,
  onLogoError,
  Errors,
}) => {
  // const { organisationsQuery } = useOrganisationContext();

  const history = useHistory();

  async function onSubmit(...args) {
    await onSubmitProp(...args);

    setTimeout(() => {
      history.push(`/core/employees`);
    }, 500);
  }
  return (
    <Page title={`${mode} Employee`}>
      <GetBack styleClass="my-2"/>
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
        validators={{
          first_name: { required },
          last_name: { required },
          email: { required },
          contact_number: { required },
          department: { required },
        }}
      >
        <FormGroup label="First name *">
          <Control.text model=".first_name" placeholder="First name" />
        </FormGroup>

        <FormGroup label="Last name *">
          <Control.text model=".last_name" placeholder="Last name" />
        </FormGroup>

        <FormGroup label="Email address *">
          <Control.text model=".email" placeholder="Email address" />
        </FormGroup>

        <FormGroup label="Contact number *">
          <Control.text model=".contact_number" placeholder="Contact number" />
        </FormGroup>

        <FormGroup label="Department *">
          <Control.text model=".department" placeholder="Contact number" defaultValue="Marketing" readOnly={true} />
        </FormGroup>
        
        <div className="my-3">
          <span><Control.checkbox model=".active" defaultValue={true} /> <Trans>Status</Trans></span>
        </div>

        {renderServerError("name")}
        
        <FormGroup className="my-3 d-flex justify-content-end">
          <SaveButton className="px-3 m-0" form={form} hidden={readOnly} />
        </FormGroup>

      </LocalForm>
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/employees",
    defaultItem: { first_name: '', last_name: '', active: true, },
  }),
  withState("serverErrors", "setServerErrors", {}),
  withState("redirectUrl", "setRedirectUrl", null),
  withHandlers({
  }),
  lifecycle({
    componentDidMount() {
      Promise.resolve().then(() => {
        const q = qs.parse(this.props.location.search);
        if (q.oauth_verifier && q.oauth_token && q.org)
          this.props.verify(q.oauth_token, q.oauth_verifier, q.org);
      });
    },
  })
);

export default enhance(HesaabEmployeeEdit);
